import React from 'react';
import Skeleton from 'react-loading-skeleton';

const Loader = ({ height = 32, width = 32 }) => {
  return <Skeleton height={'100%'} containerClassName="line-height-1 loader" />;
};

export default Loader;
